function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable linebreak-style */
// ----------------------------------------------------------------------------
// Sub-component: iamRemoveFromCartButton
// ----------------------------------------------------------------------------

// Helpers
import iamFormElement from 'scripts/classes/iamFormElement';
import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import translate from 'scripts/helpers/iamota-translate';
import registerCustomElement from 'scripts/helpers/register-custom-element';

//styles
import './_remove-from-cart-button.scss';

// -------------------------------------
// Web Component
// -------------------------------------

class iamRemoveFromCartButton extends iamFormElement {
  get namespace() {
    return "".concat(this.formName, ":items:item:").concat(this.elementName);
  }
  /**
   * Initialize the component when the product form is initialized
   */
  onFormInit() {
    // Variables
    this.state = iamRemoveFromCartButton.BUTTON_STATES.REMOVE;
    this.cartItem = this.closest('iam-cart-item');
    this.removeLink = this.querySelector('.cart__remove .cart__remove-text');

    // Validation
    if (!this.validateRequiredAttributes(['cartItem', 'removeLink'])) return;

    // Bind Event Listeners
    this.removeLink.addEventListener('click', this.onClick.bind(this));
    iamotaEventHandler.subscribe('cartForm:items:item:remove', this.onRemove.bind(this), {
      context: this.cartItem,
      source: "remove-from-cart-button.js"
    });
  }

  /**
   * Handle form submission
   * @param {event} event
   */
  onClick(event) {
    var _this = this;
    return _asyncToGenerator(function* () {
      // Block the native click behavior
      event.preventDefault();

      // Trigger item removal
      _this.cartItem.removeItem();
    })();
  }

  /**
   * Handle item removal
   */
  onRemove(_ref) {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      var {
        _event
      } = _ref;
      switch (_event) {
        case 'cartForm:items:item:remove:removing':
          _this2.setState(iamRemoveFromCartButton.BUTTON_STATES.REMOVING);
          break;
        case 'cartForm:items:item:remove:removed':
          _this2.setState(iamRemoveFromCartButton.BUTTON_STATES.REMOVED);
          break;
        case 'cartForm:items:item:remove:error':
          _this2.setState(iamRemoveFromCartButton.BUTTON_STATES.ERROR);
          break;
        default:
          _this2.setState('Unknown');
          break;
      }
    })();
  }

  /**
   * Set the current state and update the UI accordingly
   */
  setState(newState) {
    this.state = newState;
    switch (this.state) {
      case iamRemoveFromCartButton.BUTTON_STATES.REMOVE:
        this.updateButton({
          buttonText: translate('Remove', 'removeFromCart.remove', _objectSpread({}, this.cartItem))
        });
        break;
      case iamRemoveFromCartButton.BUTTON_STATES.REMOVING:
        this.updateButton({
          buttonText: translate('Removing...', 'removeFromCart.removing', _objectSpread({}, this.cartItem)),
          isDisabled: true
        });
        break;
      case iamRemoveFromCartButton.BUTTON_STATES.REMOVED:
        // Since we're removing the item from the DOM, we don't need to change anything
        // (i.e. it would just be a flash anyway)

        // this.updateButton({
        //     buttonText: translate('Removed {{ icon "remove" }}', 'removeFromCart.removed', {
        //         ...this.cartItem,
        //     }),
        //     isDisabled: true,
        //     isLoading : true,
        // });
        break;
      case iamRemoveFromCartButton.BUTTON_STATES.ERROR:
        this.updateButton({
          buttonText: translate('Error Removing', 'removeFromCart.error', _objectSpread({}, this.cartItem)),
          isDisabled: true
        });
        this.cartItem.setDisabled(false);

        // Reset to default state after a delay
        setTimeout(() => {
          this.setState(iamRemoveFromCartButton.BUTTON_STATES.REMOVE);
        }, 3000);
        break;
      default:
        console.warn("Unknown remove-from-cart-button state: ".concat(this.state));
        this.setState(iamRemoveFromCartButton.BUTTON_STATES.ERROR);
        break;
    }
  }

  /**
   * Update button UI based on the provided options
   */
  updateButton(_ref2) {
    var {
      buttonText = this.removeLink.innerHTML,
      isDisabled = false,
      isLoading = false
    } = _ref2;
    this.setText(buttonText);
    this.setLoading(isLoading);
    this.setDisabled(isDisabled, 'updateButton');
  }

  /**
   * Set the button text
   * @param {string} label
   */
  setText(buttonText) {
    var _this3 = this;
    return _asyncToGenerator(function* () {
      buttonText = yield iamotaEventHandler.applyFilters('cartForm:items:item:removeFromCartButton:buttonText', buttonText);
      _this3.removeLink.innerHTML = buttonText;
    })();
  }
}
_defineProperty(iamRemoveFromCartButton, "BUTTON_STATES", {
  REMOVE: 'remove',
  REMOVING: 'removing',
  REMOVED: 'removed',
  ERROR: 'error'
});
registerCustomElement('iam-remove-from-cart-button', iamRemoveFromCartButton);